/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Fresh_Bird_PullInputs */

const en_warm_fresh_bird_pull = /** @type {(inputs: Warm_Fresh_Bird_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All attributes`)
};

const de_warm_fresh_bird_pull = /** @type {(inputs: Warm_Fresh_Bird_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Merkmale`)
};

/**
* | output |
* | --- |
* | "All attributes" |
*
* @param {Warm_Fresh_Bird_PullInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_fresh_bird_pull = /** @type {((inputs?: Warm_Fresh_Bird_PullInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Fresh_Bird_PullInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_fresh_bird_pull(inputs)
	return de_warm_fresh_bird_pull(inputs)
});